import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import xProductPartNumbersStyles from "@pacific/App/SharedStyle/ProductPartNumbersStyles";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsUPCCodeStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
}

export const productDetailsUPCCodeStyles: ProductDetailsUPCCodeStyles = {
    labelText: xProductPartNumbersStyles.label,
    valueText: xProductPartNumbersStyles.value,
};

const styles = productDetailsUPCCodeStyles;

const ProductDetailsProductDetailsUPCCode: React.FC<Props> = ({ product }) => {
    if (!product.detail?.upcCode) {
        return null;
    }
    return (
        <Typography {...styles.valueText} as="p">
            <Typography {...styles.labelText}>{translate("UPC")}</Typography>
            {product.detail?.upcCode}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsProductDetailsUPCCode),
    definition: {
        displayName: "UPC Code",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
